import { render, staticRenderFns } from "./FieldTemplateCard.vue?vue&type=template&id=34387d57&scoped=true&"
import script from "./FieldTemplateCard.vue?vue&type=script&lang=js&"
export * from "./FieldTemplateCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/tailwind.min.css?vue&type=style&index=0&id=34387d57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34387d57",
  null
  
)

export default component.exports